import type { CopyShape } from "@tami/core/intl";

import type { DEMO_TABS_COPY_PT_BR } from "../demo-tabs.copy";

export const DEMO_TABS_COPY_EN_US: CopyShape<typeof DEMO_TABS_COPY_PT_BR> = {
  painel: "Dashboard",
  creators: "Creators",
  notas: "Notes",
  conteudo: "Content",
  campanhas: "Campaigns",
  financas: "Finances",
  calculadora: "Calculator",
  desempenho: "Performance",
  agenda: "Calendar",
  equipe: "Workflow",
  whatsapp: "WhatsApp",
};
